module.exports = __webpack_public_path__ + "img/logo-text.59b0739b.svg";